module.exports = __webpack_public_path__ + "static/BMSAlumniMBA-14e7d0dd92bdb06cd6c4792f7949f194.png";